import { defineMessages } from 'react-intl';

const messages = defineMessages({
  scrollToPrevious: {
    id: 'pgn.ChipCarousel.scrollToPrevious',
    defaultMessage: 'Scroll to previous',
    description: 'Accessibility text describing the action for navigating a scrollable carousel to the previous element',
  },
  scrollToNext: {
    id: 'pgn.ChipCarousel.scrollToNext',
    defaultMessage: 'Scroll to next',
    description: 'Accessibility text describing the action for navigating a scrollable carousel to the next element',
  },
});

export default messages;
